<template>
  <aside class="nav-utils" :class="{ 'is-active--utils': this.isActiveUtils }">
    <h2 class="a11y">사용자 메뉴</h2>

    <div class="nav-utils__links" v-if="!this.isAuthorized">
      <a href="#" @click.prevent="signIn" class="nav-utils__item"> <icon-sign-in class="icon" />로그인 </a>
      <a href="#" @click.prevent="signUp" class="nav-utils__item"> <icon-sign-up class="icon" />회원가입 </a>
      <a href="/info/cs/faq" class="nav-utils__item nav-utils--faq"> <icon-faq class="icon" />FAQ </a>
    </div>

    <div class="nav-utils__panel" v-else>
      <label class="nav-utils__item nav-utils__user" @click.stop.prevent="activateMenu">
        <a href="/me" @click.stop="trackGoingToMypage">
          <icon-user-symbol class="icon icon--user" />
          <em class="em">{{ userName }}</em>
        </a>
        <i> 님도, </i>
        <mark> 배우면 바뀐다 </mark>
        <icon-triangle class="icon icon--triangle" />
      </label>

      <ul id="nav-utils__menu" class="nav-utils__menu" @click.stop>
        <li>
          <a href="/me" class="nav-utils__a" @click="trackGoingToMypage">
            <!-- <icon-user class="icon icon- -mypage" /> -->
            내 강의 보기
          </a>
        </li>
        <li><a href="/me/enrolled" class="nav-utils__a">수강 신청 내역</a></li>
        <li><a href="/me/payment/paid" class="nav-utils__a">거래 내역</a></li>
      </ul>
    </div>
  </aside>
</template>

<script>
import IconSignIn from '../components/icons/sign-in.svg';
import IconSignUp from '../components/icons/sign-up.svg';
import IconFaq from '../components/icons/faq.svg';
// import IconUser from '../components/icons/user.svg';
import IconTriangle from '../components/icons/triangle.svg';
import IconUserSymbol from '../components/icons/user-symbol.svg';

export default {
  props: ['user-name', 'is-authorized', 'is-active-holder'],
  components: {
    IconSignIn,
    IconSignUp,
    IconFaq,
    // IconUser,
    IconTriangle,
    IconUserSymbol,
  },
  methods: {
    signIn() {
      this.$emit('emit-sign-in');
    },
    signUp() {
      this.$emit('emit-sign-up');
    },
    toggleHolder() {
      this.$emit('emit-holder');
    },
    activateMenu() {
      this.isActiveUtils = !this.isActiveUtils;
      if (this.isActiveUtils) {
        document.body.addEventListener('click', this.deactivateMenu);
      }
    },
    deactivateMenu(event) {
      this.isActiveUtils = false;
      document.body.removeEventListener('click', this.deactivateMenu);
    },
    trackGoingToMypage() {
      if (window.$fc) window.$fc.track('CLICK', { eventName: 'CLICK_MYPAGE_BUTTON', include: ['amplitude'] });
    },
  },
  data() {
    return {
      isActiveUtils: false,
    };
  },
};
</script>
